// 画面クラッシュ時に白画面ではなくエラー内容を表示する保険。
// （2026-08-11 LINE連携フローの白画面調査で追加。原因特定にも使う）
import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('[ErrorBoundary]', error, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, textAlign: 'center' }}>
          <div style={{ fontSize: 18, fontWeight: 700, margin: '32px 0 12px' }}>エラーが発生しました</div>
          <div style={{ fontSize: 12, color: '#757575', wordBreak: 'break-all', margin: '0 0 20px' }}>
            {String(this.state.error && (this.state.error.message || this.state.error))}
          </div>
          <button className="btn btn-oval btn-yellow" style={{ padding: '10px 32px' }}
            onClick={() => { window.location.href = '/'; }}>ホームへ戻る</button>
        </div>
      );
    }
    return this.props.children;
  }
}
